import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { bultenler } from './data/Bultenler.js';
import CardGrid from '../components/CardGrid';


const Kurumsal = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  

  return (
    <div className="px-4 md:px-16 py-12 space-y-12" style={{ backgroundImage: "url('/background.png')" }} >
    <section
      id="gelisim-ailesi"
      className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center px-4 py-20"
      // style={{ backgroundImage: "url('/background.png')" }} // → Görseli public/images içine koy.
    >
      <div className="bg-white/90 rounded-lg shadow-xl p-10 max-w-4xl w-full">
        <h1 className="text-3xl md:text-4xl font-bold text-[#a03838] mb-6 text-center">
          Gelişim Ailesi
        </h1>
        <p className="text-gray-800 leading-relaxed">
          Gelişim Okulları, 1999 yılının Eylül ayında eğitime başlamış, kısa sürede Mersin’in ve Türkiye’nin en başarılı okullarından biri haline gelmiştir. 2015 yılında değişen ve gelişen eğitim sistemine uyum sağlayarak liseyi de bünyesine katan ve büyümeye devam eden okulumuzda öğrenci merkezli bütüncül bir eğitim sistemi uygulanmaktadır. Gelişim okulları, anasınıfından 12. sınıfa kadar tüm öğrencilerin entelektüel ve insani niteliklerini geliştirerek, özgüveni yüksek, ahlaklı, lider nitelikli ve sorumluluk sahibi dünya vatandaşları olmalarını amaçlamaktadır.
          Felsefemiz, gelişen ve değişen dünyaya uyum sağlayan, daha önemlisi O’nu yönetebilen, kendi potansiyelinin farkında, akademik açıdan başarılı, kendi ayakları üzerinde durabilen bireyler yetiştirmektir.
          Okulumuz öğretim sisteminde öğrencilerimizin sorgulayan, araştıran, okuyan bireyler olarak yetişmesi amaçlanır ve bu doğrultuda dersler , anlatmak üzerine değil, sorgulama üzerine planlanır. Dersler sadece dinleyerek değil, katılarak, sorular sorarak, yaşayarak, araştırarak ilerler ve bu şekilde öğrenme daha kalıcı olur.
          Akademik programımızda dil öğrenimi de çok önemli bir yere sahiptir. Öğrencilerimizin İngilizceyi sadece öğrenmeleri değil, aynı zamanda hayatlarının bir parçası haline getirmeleri hedeflenir. Bu nedenle de anaokulundan 12. sınıfa kadar İngilizce dersleri yoğun bir şekilde verilmektedir.
          Okulumuzda öğretim kadar eğitim de önemlidir ve bu nedenle öğrencilerimize ahlaki değerleri aktarmak büyük önem taşımaktadır.
        </p>
        <div className="mt-8">
          <h2 className="text-2xl font-bold text-[#a03838] mb-2 border-b-2 border-[#a03838] inline-block pb-1">
            Gelişim Okulları’nın Benimsediği Değerler
          </h2>
          <ul className="list-disc list-inside text-gray-800 space-y-2 mt-4">
            <li><strong>SAYGILI</strong> olmak — insanlara, doğaya ve farklılıklara</li>
            <li><strong>ÇALIŞKAN</strong> olmak — kendisine ve topluma değer katabilmek için</li>
            <li><strong>DÜRÜST</strong> olmak — tutarlı, adaletli, doğru yoldan sapmayan bireyler olmak için</li>
            <li><strong>SORUMLULUK</strong> sahibi olmak — kişisel, sosyal ve toplumsal düzeylerde</li>
            <li><strong>FARKINDA</strong> olmak — kendinin ve toplumunun durumunun</li>
            <li><strong>HOŞGÖRÜLÜ</strong> olmak — farklılıklara ve seçimlere karşı</li>
          </ul>
        </div>

        <p>Başarı anlayışımız; Öğrencilerimizin “sosyal bilimler" ,"matematik", “bilim ve teknoloji", “dil", alanındaki akademik gelişimlerinin yanı sıra; sanat ve spor alanlarında da potansiyellerini keşfedebilmeleridir. Bu nedenle okulumuzda dans, satranç, tiyatro, tenis, masa tenisi, basketbol, voleybol, minigolf, müzik, tiyatro etkinliklerine ağırlık verilmekte. Bu etkinlikler okul sonrası ve hafta sonu çalışmalarıyla desteklenmektedir.</p>
      </div>
    </section>
    <section 
      id="yonetim">
         <h1 className="text-3xl md:text-4xl font-bold text-[#a03838] mb-6 text-center">
          Güney Gelişim Koleji Yönetim Kadrosu
        </h1>
        <p class="mb-6">
          Güney Gelişim Koleji, eğitimde mükemmelliği hedefleyen, vizyoner ve alanında deneyimli bir yönetim kadrosuna sahiptir. Kurumumuzun temelinde yalnızca akademik başarı değil, aynı zamanda ahlaki değerler, liderlik vasıfları ve toplumsal sorumluluk bilinci yer almaktadır. Bu misyonu gerçekleştirmek üzere oluşturulan yönetim kadromuz, her biri kendi alanında uzmanlaşmış ve eğitim dünyasına yön veren isimlerden oluşur.
        </p>

        <h3 class="text-2xl font-semibold text-[#a03838] mt-10 mb-2">Vizyon Sahibi Liderlik</h3>
        <p class="mb-6">
          Yönetim kadromuz, yalnızca idari görevleri yürüten değil; aynı zamanda yenilikçi, çözüm odaklı ve sürekli gelişimi teşvik eden bir anlayışla hareket eden liderlerden oluşmaktadır. 21. yüzyılın eğitim anlayışına uygun olarak; teknoloji entegrasyonu, uluslararası projeler ve bireysel gelişimi esas alan stratejilerle okulun akademik ve kültürel çıtasını daima yukarı taşımaktadır.
        </p>

        <h3 class="text-2xl font-semibold text-[#a03838] mt-10 mb-2">Deneyim ve Uzmanlık</h3>
        <p class="mb-6">
          Her biri uzun yıllara dayanan eğitimcilik tecrübesine sahip yöneticilerimiz, okul öncesinden liseye kadar tüm kademelerde aktif görev yapmış, farklı yaş gruplarının ihtiyaçlarına hâkim kişilerdir. Kadromuzda yer alan genel müdür, kampüs müdürleri, akademik koordinatörler ve bölüm başkanları, pedagojik formasyonları ve liderlik becerileriyle örnek teşkil eder.
        </p>

        <h3 class="text-2xl font-semibold text-[#a03838] mt-10 mb-2">Öğrenci Merkezli Yönetim Anlayışı</h3>
        <p class="mb-6">
          Güney Gelişim Koleji’nin yönetim anlayışı; öğrenciyi merkeze alan, her bireyin potansiyelini keşfetmesine olanak tanıyan, açık iletişimi ve katılımcılığı destekleyen bir model üzerine kuruludur. Velilerimizle sürekli diyalog içinde olan yöneticilerimiz, şeffaflık ve güven temelinde bir eğitim ortamı inşa etmektedir.
        </p>

        <h3 class="text-2xl font-semibold text-[#a03838] mt-10 mb-2">Sürekli Gelişim ve Kurumsal Değerler</h3>
        <p class="mb-6">
          Yönetim kadromuz, sadece öğrencilerimizin değil; öğretmenlerimizin, idari personelimizin ve velilerimizin de gelişimine önem verir. Sürekli eğitimler, seminerler ve iş birlikleriyle dinamik bir öğrenme kültürü yaratılırken; kurum kültürümüzü besleyen değerler (saygı, dürüstlük, sorumluluk, dayanışma) tüm süreçlerde yaşatılmaktadır.
        </p>

        <p class="mt-8 font-semibold">
          Güney Gelişim Koleji olarak, güçlü yönetim yapımızla bugünün değil, geleceğin bireylerini yetiştirmeye kararlıyız. Eğitimde fark yaratmak isteyen tüm paydaşlarımızı bu vizyonun bir parçası olmaya davet ediyoruz.
        </p>
      </section>
      <section 
      id="bulten">
         <h1 className="text-3xl md:text-4xl font-bold text-[#a03838] mb-6 text-center">
          Bülten ve Yayınlarımız
        </h1>
        <CardGrid data={bultenler} isPdfMode={true} basePath="/kurumsal" kategori='bultenler'/>
      </section>
      <section id="kvkk" className="mt-20 px-4 md:px-16 py-12 bg-white text-gray-800">
        <h2 className="text-3xl md:text-4xl font-bold text-[#a03838] mb-6 text-center">
          Kişisel Verilerin Korunması
        </h2>

        <p className="mb-6">
          Güney Gelişim Koleji olarak, öğrencilerimizin, velilerimizin, çalışanlarımızın ve diğer paydaşlarımızın kişisel verilerinin korunması konusuna büyük önem vermekteyiz. 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, veri sorumlusu sıfatıyla tüm kişisel verileri yasal çerçevede toplamakta, işlemekte ve güvenliğini sağlamaktayız.
        </p>

        <p className="mb-6">
          Okulumuzda, yalnızca eğitim-öğretim faaliyetlerinin sürdürülebilmesi, idari süreçlerin yönetilmesi, güvenlik ve iletişim ihtiyaçlarının karşılanması amacıyla kişisel veri toplanmaktadır. Bu veriler; yazılı, sözlü, görsel veya elektronik ortamlarda, açık rıza alınarak veya yasal zorunluluklar kapsamında elde edilmektedir.
        </p>

        <p className="mb-6">
          Toplanan kişisel veriler; eğitim planlaması, öğrenci kayıt işlemleri, rehberlik ve danışmanlık hizmetleri, sınav ve başarı takibi, sosyal etkinlik katılımı, acil durum iletişimi gibi hizmetler doğrultusunda sınırlı, ölçülü ve amacına uygun olarak işlenmektedir. Tüm veriler, yalnızca yetkili kişiler tarafından erişilebilecek şekilde korunur.
        </p>

        <p className="mb-6">
          Güney Gelişim Koleji, kişisel verilerin korunmasına ilişkin tüm süreçlerini düzenli olarak gözden geçirmekte ve gerekli teknik, idari tedbirleri almaktadır. Kamera sistemleri, dijital güvenlik protokolleri, erişim denetimleri ve personel eğitimleri bu kapsamda titizlikle uygulanmaktadır.
        </p>

        <p className="mb-6">
          Veri sahipleri, KVKK’nın 11. maddesi uyarınca; hangi kişisel verilerinin işlendiğini öğrenme, düzeltilmesini veya silinmesini talep etme, işleme amacını ve aktarım yapılan 3. tarafları öğrenme gibi haklara sahiptir. Bu tür talepler, okul yönetimimize yazılı olarak veya kvkk@guneygelisim.k12.tr adresine e-posta gönderilerek iletilebilir.
        </p>

        <p>
          Eğitimde güven ve şeffaflık ilkesiyle hareket eden okulumuz, tüm paydaşlarına saygı duymakta ve kişisel verilerin korunmasına dair yükümlülüklerini eksiksiz olarak yerine getirmeyi taahhüt etmektedir.
        </p>
      </section>


    </div>
  );
};

export default Kurumsal;